import { Badge, CloseButton, useMantineTheme } from "@mantine/core"
import React from "react"

import { Icon } from "@/components"

import { useStyles } from "@/components/Attachment/Attachment.styles"

const FILE_EXTENSION_MAP = {
    "7z": "file-archive",
    csv: "file-csv",
    doc: "file-word",
    docx: "file-word",
    gif: "file-image",
    ics: "calendar-alt",
    jpeg: "file-image",
    jpg: "file-image",
    keynote: "file-powerpoint",
    mp3: "file-audio",
    mp4: "file-video",
    numbers: "file-excel",
    pages: "file-word",
    pdf: "file-pdf",
    png: "file-image",
    ppt: "file-powerpoint",
    pptx: "file-powerpoint",
    rar: "file-archive",
    txt: "file-alt",
    xls: "file-excel",
    xlsx: "file-excel",
    zip: "file-archive",
}

interface AttachmentProps {
    disabled: boolean
    fileName: string
    fileExtension?: string
    onDelete: () => void
}

export const Attachment = ({ disabled, fileName, fileExtension, onDelete }: AttachmentProps) => {
    const theme = useMantineTheme()
    const { classes } = useStyles()

    const fileIcon = (
        <Icon color={theme.colors.gray[6]} icon={FILE_EXTENSION_MAP[fileExtension] || "file"} iconFamily="fal" />
    )

    const closeButton = (
        <CloseButton
            aria-label={`Delete Attachment: ${fileName}`}
            disabled={disabled}
            onClick={onDelete}
            variant="transparent"
        />
    )

    return (
        <Badge classNames={classes} leftSection={fileIcon} rightSection={closeButton}>
            {fileName}
        </Badge>
    )
}
